// extracted by mini-css-extract-plugin
export default {"container":"pMkMQ4","file-preview-icon":"wLy6r5","file-preview-image":"EW0kmz"};